<template>
  <div class="page article-list-page flex-col">
    <AppHeader />
    <!-- <van-nav-bar :title="pageTitle" :fixed="true" left-arrow @click-left="$router.back()" :border="false" class="custom-nav" /> -->
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" >
          <div class="article-card flex-row" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
            <div class="article-thumb-box">
              <img class="article-thumb" :src="item.img || defaultThumb" />
            </div>
            <div class="article-info flex-col justify-between">
              <span class="article-title">{{ item.title }}</span>
              <span class="article-desc" v-if="item.description || item.desc">{{ item.description || item.desc }}</span>
              <span class="article-date">{{ item.publishTime || item.createTime || item.date }}
                 <span class="times">  &#x1F441;   {{ item.hit || 99 }}</span>
              </span>
             
            </div>
          </div>
          <div class="empty-state" v-if="!loading && list.length === 0">
            <p class="empty-state-text">暂无数据</p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <BackTop />
    <CopyrightFooter />
  </div>
</template>

<script>
import { NavBar, List, PullRefresh } from 'vant'
import { contentList } from '../api/content'
import { getColumnNameById } from '../utils/common'
import CopyrightFooter from './components/CopyrightFooter.vue'
import BackTop from './components/BackTop.vue'
import AppHeader from './components/AppHeader.vue'

export default {
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    CopyrightFooter,
    BackTop,
    AppHeader
  },
  data() {
    return {
      pageTitle: '文章列表',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      pageSize: 10,
      defaultThumb: require('./assets/img/article-thumb-1.png'),
    }
  },
  mounted() {
    this.pageTitle = this.getTitleByCategory(this.$route.query.categoryId)
    this.onRefresh()
    document.title = this.pageTitle  + " - "+ window.__appBasic.appName
  },
  methods: {
    getTitleByCategory(id) {
      return getColumnNameById(id) || '文章列表'
    },
    async onLoad() {
      try {
        const res = await contentList({ categoryId: this.$route.query.categoryId, pageNum: this.pageNum, pageSize: this.pageSize })
        const rows = (res.rows || []).map(item => ({
          ...item,
          img: item.litpic ? JSON.parse(item.litpic)[0].url : ''
        }))
        if (this.refreshing) {
          this.list = rows
        } else {
          this.list = this.list.concat(rows)
        }
        this.pageNum += 1
        if (rows.length < this.pageSize) this.finished = true
      } catch (e) {
        console.error('获取文章列表失败：', e)
        this.$toast('加载失败，请稍后重试')
        this.finished = true
      } finally {
        this.loading = false
        this.refreshing = false
      }
    },
    onRefresh() {
      this.pageNum = 1
      this.finished = false
      this.onLoad()
    },
    goDetail(item) {
      if (item && item.id) {
        this.$router.push('/article/' + item.id)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.article-list-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.custom-nav {
  background-color: #0464CA;
  ::v-deep .van-nav-bar__title { color: #fff; font-weight: 600; }
  ::v-deep .van-nav-bar__arrow { color: #fff; }
}
.content {
  padding: 12px 16px;
  // margin-top: 45px;
}
.article-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
  &:active {
    transform: scale(0.97);
    opacity: 0.88;
  }
}
.article-thumb-box {
  width: 100px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
}
.article-thumb {
  width: 100%;
}
.article-info {
  flex: 1;
  overflow: hidden;
}
.article-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.article-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.article-date {
  font-size: 11px;
  color: #999;
  margin-top: 6px;
  .times{
    margin-left: 20px;
  }
}
</style>
